import { createContext } from 'react'

export const PostsWidgetContext = createContext()
